export default {
  SET_unitsOfMeasure(state, value) {
    state.unitsOfMeasure = value;
  },
};
